/**
 * React bindings for the active tenant.
 *
 * Separated from `TenantContext.tsx` so the provider module exports only components
 * (which is what React Fast Refresh needs) while these hooks stay importable from
 * anywhere.
 */

import { useContext } from 'react';

import { TenantContext, type TenantContextValue } from './tenantContextValue';

export function useTenantContext(): TenantContextValue {
  const value = useContext(TenantContext);
  if (value === null) {
    throw new Error('useTenantContext 必须在 TenantProvider 内部使用。');
  }
  return value;
}

/**
 * Tenant id for business queries. Pages call this and therefore cannot issue a
 * request without an explicit tenant scope.
 */
export function useRequiredTenantId(): string {
  const { tenant } = useTenantContext();
  if (tenant === null) {
    throw new Error('尚未选择租户，业务查询不应发起。');
  }
  return tenant.id;
}
